module.exports = __webpack_public_path__ + "img/mobile-bg.aa179a73.png";